import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="card text-center">
      <h1 className="text-2xl font-semibold">404</h1>
      <p className="text-sm text-slate-500">Page not found.</p>
      <Link to="/" className="mt-2 inline-block text-brand-700 hover:underline">
        Back to dashboard
      </Link>
    </div>
  );
}
